<template>
  <v-container fluid grid-list-md text-xs-center style="min-height: 93.4vh">
    <v-layout row wrap>
      <v-toolbar scroll-target="#scrolling-home" style="height: 74px">
        <v-toolbar-title v-show="!$vuetify.breakpoint.xsOnly">
          {{ $t('surveys.surveys_title') }}
        </v-toolbar-title>
        <v-layout
          style="margin-top: 5px"
          wrap
          fill-height
          align-center
          justify-end
          v-if="!$vuetify.breakpoint.xsOnly"
        >
          <v-flex xs12 offset-md6 md6 v-show="!$vuetify.breakpoint.xsOnly">
            <v-layout row wrap>
              <v-flex xs12 sm10 offset-sm2 class="titleSearch">
                <v-text-field
                  flat
                  :label="$t('generic.search')"
                  append-outer-icon="search"
                  clearable
                  solo-inverted
                  hide-details
                  @click:append-outer="filterSearch(false)"
                  @click:clear="filterSearch(true)"
                  @keyup.enter="filterSearch(false)"
                  v-model="search"
                />
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-speed-dial
          v-if="userPermissions[possibleUserModulePermissions.ADD_POLLS]"
          key="1"
          absolute
          bottom
          left
          direction="bottom"
          :open-on-hover="true"
          transition="scale-transition"
          style="bottom: 0"
        >
          <template v-slot:activator>
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-btn
                  style="z-index: 99"
                  color="gradiente"
                  dark
                  fab
                  :small="$vuetify.breakpoint.xsOnly"
                >
                  <v-icon>more_vert</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('generic.options') }}</span>
            </v-tooltip>
          </template>
          <v-tooltip right>
            <v-btn
              fab
              dark
              small
              color="gradiente"
              slot="activator"
              @click="createNewPoll('NORMAL')"
            >
              <v-icon>equalizer</v-icon>
            </v-btn>
            <span>{{ $t('surveys.custom_survey') }}</span>
          </v-tooltip>
          <v-tooltip right>
            <v-btn
              fab
              dark
              small
              color="gradiente"
              slot="activator"
              @click="createNewPoll('COVID')"
            >
              <v-icon>coronavirus</v-icon>
            </v-btn>
            <span>Encuesta covid</span>
          </v-tooltip>
        </v-speed-dial>
      </v-toolbar>
      <v-container
        elevation-2
        fluid
        id="scrolling-activity"
        style="max-height: 77vh"
        class="table-full"
      >
        <v-layout row wrap>
          <v-flex xs12>
            <v-data-table
              :headers="headers"
              :rows-per-page-items="[10, 25]"
              :items="polls"
              :loading="working.wPolls"
              :pagination.sync="pagination"
              item-key="id"
              no-results-text="No se encontraron coincidencias"
              :no-data-text="
                userPermissions[possibleUserModulePermissions.WATCH_POLLS]
                  ? working.wPolls
                    ? 'Cargando'
                    : polls.length > 0
                    ? ''
                    : 'No hay encuestas'
                  : 'No tienes permiso de ver encuestas'
              "
              :total-items="totalItemsFromBackend"
            >
              <template v-slot:headers>
                <tr>
                  <th
                    class="text-xs-left"
                    style="width: 270px; max-width: 270px; min-width: 270px"
                  >
                    {{ $t('surveys.name') }}
                  </th>
                  <th
                    class="text-xs-left"
                    style="width: 200px; max-width: 200px; min-width: 200px"
                  >
                    {{ $t('surveys.frequency') }}
                  </th>
                  <th
                    class="text-xs-left"
                    style="width: 210px; max-width: 210px; min-width: 210px"
                  >
                    {{ $t('surveys.publication_date') }}
                  </th>
                  <th
                    class="text-xs-left"
                    style="width: 160px; max-width: 160px; min-width: 160px"
                  >
                    {{ $t('surveys.status') }}
                  </th>
                  <th
                    class="text-xs-left"
                    style="width: 160px; max-width: 160px; min-width: 160px"
                  >
                    {{ $t('surveys.alert_responses') }}
                  </th>
                  <th style="width: 320px; max-width: 320px; min-width: 320px">
                    &nbsp;
                  </th>
                </tr>
              </template>
              <template v-slot:items="props">
                <td
                  class="text-xs-left"
                  style="width: 270px; max-width: 270px; min-width: 270px"
                >
                  {{ props.item.title }}
                </td>
                <td
                  class="text-xs-left"
                  style="width: 200px; max-width: 200px; min-width: 200px"
                >
                  {{ props.item.periodicity | periodicity }}
                </td>
                <td
                  class="text-xs-left"
                  style="width: 210px; max-width: 210px; min-width: 210px"
                >
                  {{ props.item.createDate | formatDateShort }}
                </td>
                <td
                  class="text-xs-left"
                  style="width: 160px; max-width: 160px; min-width: 160px"
                >
                  <v-layout row>
                    <v-flex style="align-self: center">
                      <v-img
                        :src="getIcon(props.item.status)"
                        width="16px"
                      ></v-img>
                    </v-flex>
                    <v-flex style="align-self: center">
                      {{ pollStatus(props.item.status) }}
                    </v-flex>
                  </v-layout>
                </td>
                <td
                  class="text-xs-left"
                  style="width: 160px; max-width: 160px; min-width: 160px"
                  center
                >
                  <v-layout center style="margin-left: 35px">
                    <div>
                      <v-img
                        :src="require('@/assets/polls/icons/alerta2.png')"
                        width="25px"
                        height="25px"
                        center
                      ></v-img>
                    </div>
                    <div style="margin-left: 15px">
                      {{ props.item.alertCount }}
                    </div>
                  </v-layout>
                </td>
                <td
                  style="width: 320px; max-width: 320px; min-width: 320px"
                  class="text-xs-right"
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        @click="viewPoll(props.item)"
                        icon
                        :disabled="
                          !userPermissions[
                            possibleUserModulePermissions.WATCH_POLLS
                          ]
                        "
                      >
                        <v-icon>visibility</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('surveys.view_survey') }}</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        @click="editPoll(props.item)"
                        icon
                        :disabled="
                          !userPermissions[
                            possibleUserModulePermissions.UPDATE_POLLS
                          ]
                        "
                        v-if="props.item.status != 'FINISHED'"
                      >
                        <v-icon>edit</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('surveys.edit_survey') }}</span>
                  </v-tooltip>
                  <v-btn icon v-if="props.item.status == 'FINISHED'" disabled>
                    <v-icon>minimize</v-icon>
                  </v-btn>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        @click="copyPoll(props.item)"
                        icon
                        :disabled="
                          !userPermissions[
                            possibleUserModulePermissions.UPDATE_POLLS
                          ]
                        "
                      >
                        <v-icon>content_copy</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('surveys.make_survey_copy') }}</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        icon
                        v-if="props.item.status == 'READY'"
                        @click="stopPollM(props.item.id)"
                      >
                        <v-icon>stop_circle</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('surveys.stop_survey') }}</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        icon
                        v-if="props.item.status == 'DISABLED'"
                        @click="resumenPollM(props.item.id)"
                      >
                        <v-icon>play_circle</v-icon>
                      </v-btn>
                    </template>
                    <span>Reanudar Encuesta</span>
                  </v-tooltip>
                  <v-btn
                    icon
                    v-if="
                      props.item.status != 'DISABLED' &&
                      props.item.status != 'READY'
                    "
                    disabled
                  >
                    <v-icon>minimize</v-icon>
                  </v-btn>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        @click="deletePoll(props.item)"
                        icon
                        :disabled="
                          !userPermissions[
                            possibleUserModulePermissions.UPDATE_POLLS
                          ]
                        "
                      >
                        <v-icon>delete</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('surveys.delete_survey_title') }}</span>
                  </v-tooltip>
                </td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>
    </v-layout>

    <CreatePoll
      v-model="modals.createPoll"
      :typePoll="typePoll"
      :poll="poll"
      :isEdit="isEdit"
      :edit="edit"
      @created="onNewPoll"
      @onClosed="onCancel"
      @loading="onLoading"
    />

    <PollEditReady
      v-model="modals.editPollReady"
      :poll="poll"
      @cancelled="onCancel"
      @created="onEditPoll"
    />

    <PollSummary v-model="modals.summary" :poll="poll" />

    <PollSummaryColl v-model="modals.summaryCol" :poll="poll" />

    <desition
      @desition="$event ? onDeletePoll() : ''"
      v-model="modals.confirmDelete"
      :title="$t('surveys.delete_survey_title')"
      :description="$t('surveys.delete_survey_description')"
    />

    <loading v-model="working.wLoading" text="Trabajando" />
    <success v-model="toast.success" text="Operación exitosa" />
    <error v-model="toast.failed" text="Ups ocurrió un error" />
    <PollStop
      v-model="stopPoll"
      :poll="pollId"
      @updated="getPolls(true)"
    ></PollStop>
    <PollResumen
      v-model="resumenPoll"
      :poll="pollId"
      @updated="getPolls(true)"
    ></PollResumen>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { _getUserPermissions } from '../../../utils/genericUtils.js'
import desition from '../../Dialogs/Confirm'
import error from '../../Dialogs/Error'
import loading from '../../Dialogs/Loading'
import PollResumen from '../../Dialogs/PollResumen.vue'
import PollStop from '../../Dialogs/PollStop.vue'
import success from '../../Dialogs/Success'
import CreatePoll from '../../Sections/Polls/CreatePollModal.vue'
import PollEditReady from '../../Sections/Polls/PollEditReadyModal.vue'
import PollSummary from '../../Sections/Polls/PollSummaryModal.vue'
import PollSummaryColl from '../../Sections/Polls/PollSummaryModalCol.vue'

export default {
  components: {
    loading,
    success,
    error,
    desition,
    CreatePoll,
    PollSummary,
    PollSummaryColl,
    PollEditReady,
    PollResumen,
    PollStop,
  },
  data: () => ({
    possibleUserModulePermissions: {
      WATCH_POLLS: 'WATCH_POLLS',
      ADD_POLLS: 'ADD_POLLS',
      UPDATE_POLLS: 'UPDATE_POLLS',
    },
    userPermissions: {},
    user: {},
    pagination: {
      sortBy: 'name',
    },
    filters: {
      search: '',
    },
    search: '',
    flags: {
      loading: false,
    },
    toast: {
      success: false,
      failed: false,
    },
    modals: {
      createPoll: false,
      confirmDelete: false,
      editPollReady: false,
      summary: false,
      summaryCol: false,
    },
    working: {
      wPolls: false,
      wLoading: false,
    },
    polls: [],
    poll: null,
    typePoll: null,
    isEdit: false,
    edit: false,
    anyResult: '',
    totalItemsFromBackend: 0,
    headers: [
      {
        text: 'Nombre',
        align: 'left',
        value: 'title',
        filterItems: [],
      },
      {
        text: 'Periodicidad',
        value: 'periodicity',
        align: 'left',
        filterItems: [],
      },
      {
        text: 'Fecha de publicación',
        value: 'startDate',
        align: 'left',
        filterItems: [],
      },
      {
        text: 'Estatus',
        value: 'alertCount',
        align: 'left',
        filterItems: [],
      },
      {
        text: 'Respuestas de alerta',

        align: 'left',
        filterItems: [],
      },
      {
        text: '',
        value: 'id',
        filterItems: [],
        align: 'center',
      },
    ],
    stopPoll: false,
    resumenPoll: false,
    pollId: '',
  }),
  filters: {
    periodicity: function (value) {
      switch (value) {
        case 'SINGLE':
          return 'Una sola vez'
        case 'DAILY':
          return 'Diario'
        case 'WEEKLY':
          return 'Semanal'
        case 'MONTHLY':
          return 'Mensual'
        default:
          return 'Una sola vez'
      }
    },
  },
  methods: {
    pollStatus: function (value) {
      switch (value) {
        case 'DRAFT':
          return 'Pendiente'
        case 'READY':
          return this.$t('surveys.published')
        case 'DISABLED':
          return 'Detenida'
        default:
          return this.$t('surveys.completed')
      }
    },
    resumenPollM(id) {
      this.pollId = id
      this.resumenPoll = true
    },
    stopPollM(id) {
      this.pollId = id
      this.stopPoll = true
    },

    editPoll(poll) {
      this.poll = poll
      this.modals.createPoll = true
      this.working.wLoading = true
      if (this.poll.status == 'DRAFT') {
        this.isEdit = false
        this.edit = true
      } else {
        this.isEdit = true
        this.edit = true
      }
      console.log(this.poll.status)
      console.log(this.isEdit)
      console.log(this.edit)
    },
    copyPoll(poll) {
      this.working.wLoading = true
      this.$store
        .dispatch('polls/copyPoll', poll.id)
        .then(() => {
          this.working.wLoading = false
          this.toast.success = true
          this.getPolls(true)
        })
        .catch(() => {
          this.toast.failed = true
          this.working.wLoading = false
        })
    },
    viewPoll(poll) {
      this.poll = poll
      if (poll.audience.webRoleIds != null) {
        if (poll.audience.webRoleIds.length > 0) {
          this.modals.summaryCol = true
        } else {
          this.modals.summary = true
        }
      } else {
        this.modals.summary = true
      }
    },
    deletePoll(poll) {
      this.poll = poll
      this.modals.confirmDelete = true
    },
    onDeletePoll() {
      this.working.wLoading = true
      this.$store
        .dispatch('polls/deletePoll', this.poll.id)
        .then(() => {
          this.working.wLoading = false
          this.toast.success = true
          this.getPolls(true)
        })
        .catch(() => {
          this.toast.failed = true
          this.working.wLoading = false
        })
    },
    onCancel() {
      this.modals.editPollReady = false
      this.modals.createPoll = false
      this.modals.confirmDelete = false
      this.modals.summary = false
      this.edit = false
      this.$forceUpdate()
    },
    onLoading(show) {
      this.working.wLoading = show
    },
    onEditPoll(success, pollEdit) {
      this.modals.editPollReady = false
      if (success) {
        this.polls.splice(this.polls.indexOf(this.poll), 1, pollEdit)
        this.poll = null
        this.toast.success = true
        this.toast.failed = false
        this.$forceUpdate()
      } else {
        this.toast.failed = true
        this.toast.success = false
      }
    },
    onNewPoll(event) {
      this.working.wLoading = false
      if (event.success) {
        event.new = true
        this.modals.createPoll = false
        this.toast.success = true
        this.getPolls(true)
      } else {
        this.toast.failed = true
      }
    },
    mapPermits() {
      this.userPermissions = _getUserPermissions({
        getUser: this.getUser,
        possibleUserModulePermissions: this.possibleUserModulePermissions,
      })
    },
    filterSearch(clean) {
      if (!clean) {
        this.filters.search = this.search ? this.search : ''
      } else {
        this.filters.search = ''
      }
      if (!this.working.wLoading) {
        this.getPolls(true)
      }
    },
    createNewPoll(type) {
      this.poll = null
      this.typePoll = type
      this.isEdit = false
      this.modals.createPoll = true
    },
    getPolls(forceUpdate) {
      var offset = (this.pagination.page - 1) * this.pagination.rowsPerPage
      this.working.wPolls = true
      this.$store
        .dispatch('polls/getPolls', {
          search: this.filters.search,
          page_size: this.pagination.rowsPerPage,
          offset: offset,
        })
        .then((response) => {
          this.working.wPolls = false
          this.polls = response.data.items
          this.totalItemsFromBackend = response.data.total
          if (forceUpdate) {
            this.$forceUpdate()
          }
        })
        .catch(() => {
          this.working.wPolls = false
        })
    },
    getIcon(status) {
      switch (status) {
        case 'DRAFT':
          return require('@/assets/payments/payment_status_draft.png')
        case 'READY':
          return require('@/assets/payments/payment_status_enabled.png')
        case 'ENABLED':
          return require('@/assets/payments/payment_status_enabled.png')
        default:
          return require('@/assets/payments/payment_status_draft.png')
      }
    },
    handleKeyDown(e) {
      //method to handle the keypress
      if (e.code === 'Escape') {
        this.onCancel()
      }
    },
    onCancel() {
      this.modals.createPoll = false
      this.modals.confirmDelete = false
      this.modals.editPollReady = false
      this.modals.summary = false
      this.modals.summaryCol = false
      this.$forceUpdate()
    },
  },
  created() {
    window.addEventListener('keydown', this.handleKeyDown) //will attach the event listener to the whole window when the component is created
  },
  destroyed() {
    window.removeEventListener('keydown', this.handleKeyDown) //will detach the event listener once the component is destroyed
  },
  mounted() {
    if (this.getUser.id) this.mapPermits()
    if (
      this.userPermissions[this.possibleUserModulePermissions.WATCH_POLLS] &&
      !this.polls.length > 0
    ) {
      this.getPolls(true)
    }
  },
  watch: {
    getUser() {
      if (this.getUser.id) this.mapPermits()
      if (
        this.userPermissions[this.possibleUserModulePermissions.WATCH_POLLS] &&
        !this.polls.length > 0
      ) {
        this.getPolls(true)
      }
    },
    pagination: {
      handler() {
        if (
          this.pagination.rowsPerPage &&
          this.pagination.page &&
          this.pagination.sortBy
        ) {
          this.filters.size = this.pagination.rowsPerPage
          this.filters.offset =
            (this.pagination.page - 1) * this.pagination.rowsPerPage
          this.filters.orderBy = this.pagination.sortBy
          this.filters.orderType = this.pagination.descending ? 'DESC' : 'ASC'
          if (
            this.userPermissions[this.possibleUserModulePermissions.WATCH_POLLS]
          ) {
            this.getPolls(true)
          }
        }
      },
    },
  },
  computed: {
    ...mapGetters(['getUser']),
  },
}
</script>

<style>
.titleSearch .v-input .v-input__slot {
  border-radius: 33px !important;
}

.v-text-field--box .v-input__slot,
.v-text-field--outline .v-input__slot {
  display: flex !important;
  align-items: center !important;
  min-height: auto !important;
}
</style>
<style scoped>
::v-deep .table-full .v-datatable.v-table > tbody {
  max-height: calc(108vh - 426px);
  min-height: calc(108vh - 426px);
}
</style>
